import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Button, Col, Form, OverlayTrigger, Row, Spinner, Tooltip } from 'react-bootstrap';
import Card from '../../components/Card';
import UserService from '../../services/user/UserService';
import DataTable from 'react-data-table-component';
import Negara from '../../utilities/Negara';
import { FaEdit, FaPlus } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const Partner = () => {
    const columns = [
        {
            name: 'Nomor ID',
            cell: row => row['noId'],
            grow: 0.25
        },
        {
            name: 'Nama',
            cell: row => row['nama'],
            grow: 0.5
        },
        {
            name: 'Alamat',
            cell: row => row['alamat']
        },
        {
            name: 'Negara',
            cell: row => <Negara id={row['negara']} />,
            grow: 0.25
        },
        {
            name: 'Action',
            cell: row => (
                <>
                    {
                        localStorage.getItem("kodeTrader") !== null &&
                        <div className="row">
                            <div className="col-12 mb-1">
                                <OverlayTrigger placement="bottom" overlay={
                                    <Tooltip >Ubah Partner</Tooltip>}>

                                    <Button size="sm" variant="warning" onClick={() => handleClickEditPartner(row)}>
                                        <FaEdit />
                                    </Button>
                                </OverlayTrigger>
                            </div>
                        </div>
                    }
                </>
            ),
            grow: 0
        }

    ]

    let userService = useMemo(() => new UserService(), [])
    let navigate = useNavigate()

    const [listPartner, setlistPartner] = useState([])
    const [size, setSize] = useState(10)
    const [totalData, setTotalData] = useState(0)
    const [loading, setLoading] = useState(false)

    const getlistPartner = useCallback(async (page, size) => {
        setLoading(true)
        try {
            const response = await userService.listPartnerByTrader(localStorage.getItem('kodeTrader') !== null ? localStorage.getItem('kodeTrader') : null, null, page, size)
            setlistPartner(response.data.data)
            setTotalData(response.data.totalData)
        } catch (error) {
            console.log(error)
            setlistPartner([])
        }
        setLoading(false)
    }, [userService])

    useEffect(() => {
        getlistPartner(0, 10)
    }, [getlistPartner])

    const handleChangePage = (page) => {
        getlistPartner(page - 1, size)
    }

    const handlePerRowsChange = async (size, page) => {
        const _res = await userService.listPartnerByTrader(localStorage.getItem('kodeTrader') !== null ? localStorage.getItem('kodeTrader') : null, null, page - 1, size)
        setlistPartner(_res.data.data)
        setSize(size)
    }

    const handleClickTambahPartner = () => {
        localStorage.removeItem("dataPartnerStorage")
        navigate('/setting/partner-add-edit')
    }

    const handleClickEditPartner = (data) => {
        localStorage.removeItem("dataPartnerStorage")
        localStorage.setItem("dataPartnerStorage", JSON.stringify(data, null, 2))
        navigate('/setting/partner-add-edit')
    }

    const [valueSearch, setValueSearch] = useState(null)
    const [loadingSearch, setLoadingSearch] = useState(false)

    const onChangeSearch = e => {
        setValueSearch(e.target.value)
    }

    const handleClickReset = () => {
        setValueSearch('')
        getlistPartner(0, 10)
    }

    const handleClickCari = async () => {
        setLoadingSearch(true)
        const _res = await userService.listPartnerByTrader(localStorage.getItem('kodeTrader') !== null ? localStorage.getItem('kodeTrader') : null, valueSearch, 0, size)
        setlistPartner(_res.data.data)
        setTotalData(_res.data.totalData)
        setLoadingSearch(false)
    }

    return (
        <>
            <Row>
                <Col sm="12">
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">Pencarian Data</h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                            <div className="row">
                                <div className="col-sm-6">
                                    <Form>
                                        <Form.Group as={Row} className="form-group">
                                            <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Nama Partner</Form.Label>
                                            <Col sm="6">
                                                <Form.Control type="searchNib" placeholder="Nama Partner" className="form-control-sm" value={valueSearch} onChange={onChangeSearch} />
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <Form>
                                        <Form.Group as={Row} className="form-group">
                                            <Col sm="2">
                                                <Button type="button" variant="btn btn-primary" size="sm" onClick={() => handleClickCari()} disabled={loadingSearch}>{loadingSearch && <Spinner/>}Cari</Button>{' '}
                                                <Button type="button" variant="btn btn-danger" size="sm" onClick={() => handleClickReset()}>Reset</Button>{' '}
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">Daftar Partner</h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                            {
                                localStorage.getItem("kodeTrader") !== null &&
                                <Button type="button" variant="primary" size="sm" onClick={() => handleClickTambahPartner()} ><FaPlus /> Tambah</Button>
                            }
                            <div className="table-responsive border-bottom my-3">
                                {(loading && <Spinner />)}
                                <DataTable
                                    customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                                    columns={columns}
                                    data={listPartner}
                                    highlightOnHover
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalData}
                                    onChangePage={handleChangePage}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                    persistTableHead={true}
                                />
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    );
}

export default Partner